import NavMessage from './NavMessage';
import './style/index.less';

export default NavMessage;
